module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-2.43693006.jpg";